import { useEffect } from 'react';
import { getPermissions } from '../../store/nerisSettingsAuthoritiesReducer';
import { useDispatch } from 'react-redux';

const NerisPermissions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const pages = JSON.parse(localStorage.getItem('pages'));

    const isHaveNeris = pages.includes('V3_NERIS_MODULE');
    if (isHaveNeris) {
      dispatch(
        getPermissions({
          employee: user.Emp_Code,
          rank: user.employee_assignment.EA_Rank,
        })
      );
    }
  }, [dispatch]);

  return null;
};

export default NerisPermissions;
